// Axios interceptors — ARTEKNOS
// Auto-ajoute le Bearer token admin sur toutes les requêtes /api/admin/*
// Gère aussi les 401 en forçant le logout admin.
import axios from "axios";

const ADMIN_API_PATTERN = /\/api\/admin\//;
// On exclut les endpoints publics qui ne requièrent PAS de token :
const PUBLIC_ADMIN_ENDPOINTS = [/\/api\/admin\/login$/, /\/api\/admin\/info$/];

function getAdminToken() {
  try {
    const raw = sessionStorage.getItem("admin_session");
    if (!raw) return null;
    const { token, ts, expires_in } = JSON.parse(raw);
    const ttlMs = (expires_in || 7200) * 1000;
    if (token && typeof ts === "number" && Date.now() - ts < ttlMs) {
      return token;
    }
    // expiré
    sessionStorage.removeItem("admin_session");
    return null;
  } catch {
    return null;
  }
}

function isPublicAdminEndpoint(url) {
  if (!url) return false;
  return PUBLIC_ADMIN_ENDPOINTS.some((re) => re.test(url));
}

// Request: Bearer admin sur /api/admin/*, sinon Bearer utilisateur (session client/livreur/commerçant)
axios.interceptors.request.use((config) => {
  const url = config.url || "";
  if (ADMIN_API_PATTERN.test(url)) {
    if (!isPublicAdminEndpoint(url)) {
      const token = getAdminToken();
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  } else if (url.includes("/api/")) {
    // Pages admin : le jeton admin donne accès aux données complètes (/partners, /couriers…)
    const onAdminPage = /^\/admin/.test(window.location.pathname);
    const adminToken = onAdminPage ? getAdminToken() : null;
    const userToken = adminToken || localStorage.getItem("auth_token");
    if (userToken && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${userToken}`;
    }
  }
  return config;
});

// Response: sur un 401 côté admin, on déclenche une redirection vers la page admin de login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 401 && !ADMIN_API_PATTERN.test(url) && typeof detail === "string" && detail.startsWith("Session expirée")) {
      localStorage.removeItem("user");
      localStorage.removeItem("auth_token");
      if (!window.location.pathname.startsWith("/auth")) window.location.href = "/auth";
    }
    if (status === 401 && ADMIN_API_PATTERN.test(url) && !isPublicAdminEndpoint(url)) {
      sessionStorage.removeItem("admin_session");
      // Si on est déjà sur la page admin, on force un reload pour afficher le formulaire de login
      if (window.location.pathname.startsWith("/admin-private-126")) {
        // Evite les boucles infinies (on ne reload que si on était déjà authentifié)
        const alreadyReloaded = sessionStorage.getItem("admin_just_logged_out");
        if (!alreadyReloaded) {
          sessionStorage.setItem("admin_just_logged_out", "1");
          setTimeout(() => {
            sessionStorage.removeItem("admin_just_logged_out");
            window.location.reload();
          }, 100);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
